<template>
    <div v-if="selectedBuild" class="row">
        <ul
            class="nav nav-tabs sb-tab text-center"
            role="tablist"
        >
            <li
                @click="selectedBuild = build"
                v-for="build in builds"
                class="sb-tab--option"
                :class="[build.tabClass, { 'active': selectedBuild.id == build.id }]"
                :key="build.name"
            >
                <a
                    class="text-bold"
                    data-toggle="tab"
                    role="tab"
                    :href="`#${build.id}`"
                >
                    <span class="build-name build-name__short text-uppercase">
                        {{ build.shortName }}
                    </span>
                    <span class="build-name text-uppercase">
                        {{ build.details.build.name }}
                    </span>
                </a>
            </li>
        </ul>
        <div class="tab-content bg-white">
            <promo-builds
                v-for="build in builds"
                :key="build.details.build.name"
                :build="build"
                :promo-id="STREAM_BUNDLE_PROMO_ID"
                :selected-build="selectedBuild"
                @is-loading="loading => isLoading = loading"
            />
        </div>

        <div v-if="isLoading" class="loading">
            <p>Processing</p>
        </div>
    </div>
</template>

<script>
import PromoBuilds from "./promo-build.vue";
import CONSTANTS from "../../../../../config/constants.js";

export default {
    name: "BuildTabs",
    components: {
        PromoBuilds
    },
    data () {
        return {
            selectedBuild: null,
            STREAM_BUNDLE_PROMO_ID: 28,
            isLoading: false,
            builds: [
                {
                    id: 4,
                    shortName: 'PC',
                    tabClass: "sb-tab--option__blue",
                },
                {
                    id: 5,
                    shortName: 'ESSENTIALS',
                    tabClass: "sb-tab--option__d-blue",
                },
                {
                    id: 6,
                    shortName: 'PREMIUM',
                    tabClass: "sb-tab--option__purple",
                }
            ]
        }
    },
    created() {
        this.getPromoData();
    },
    methods: {
        getPromoData() {
            axios({
                url: `/sites/${CONSTANTS.SITES.LETSBLD}/promos/${this.STREAM_BUNDLE_PROMO_ID}/builds`
            }).then(response => {
                const data = response.data;
                this.builds = this.builds.map(build => {
                    build.details = data.find(info => info.id == build.id);
                    return build;
                });

                this.selectedBuild = this.builds.find(build => build.shortName == "ESSENTIALS");
            });
        }
    }
};
</script>

<style lang="scss" scoped>
@import '~@s/_asset-mixers.scss';

.loading {
    color: white;
    background-color: rgba(17, 17, 17, 0.9);
}

.sb-tab {
    display: flex;
    flex-flow: row;
    align-items: center;
    justify-content: center;
    background-color: #4a4a4a;
    border: 0;
    &--option {
        width: 100%;
        overflow: hidden;

        // modifiers
        &__blue {
            background-color: #858585;
        }
        &__d-blue {
            background-color: #595959;
        }
        &__purple {
            background-color: $purple;
        }

        &.active,
        &:hover,
        &:visited,
        &:focus {
            margin-top: -10px;
            padding-top: 12px;
            a {
                border: 0;
                background-color: initial !important;
            }
        }

        a {
            font-size: 36px;
            font-family: "Akkurat-Bold";
            border-radius: 0;
            margin: 0;
            max-width: 100%;
            overflow: hidden;
            text-overflow: clip;
            white-space: nowrap;
        }

        a,
        &.active a,
        &:hover a {
            color: white;

            &:hover,
            &:visited,
            &:focus {
                border: 0;
                color: white;
            }
        }

        .build-name__short {
            display: none;
        }
    }
}
@media screen and (max-width: 1200px) and (min-width: 320px) {
    .sb-tab {
        &--option {
            a {
                font-size: 25px;
            }
        }
    }
}
@media (max-width: 990px) and (min-width: 320px)  {
    .nav  {
        li  {
            a {
                padding: 10px 8px;
            }
        }
    }

    .sb-tab {
        &--option {
            .build-name {
                display: none;
                font-size: 15px;

                &__short {
                    display: block;
                }
            }
        }
    }
}
</style>
